'use client';

interface BannerPreviewPanelProps {
  previewUrl: string;
}

export function BannerPreviewPanel({ previewUrl }: BannerPreviewPanelProps): React.JSX.Element {
  return (
    <div className="space-y-4 bg-[#f2f3f7] px-6 py-4 dark:bg-[#1B1D22]">
      <div>
        <p className="mb-2 text-xs font-medium text-muted-foreground">На компьютере</p>
        <div className="relative h-40 w-full overflow-hidden rounded-2xl bg-muted md:h-48">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={previewUrl}
            alt="Предпросмотр фона на компьютере"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
      <div className="mx-auto w-full max-w-[280px]">
        <p className="mb-2 text-xs font-medium text-muted-foreground">На телефоне</p>
        <div className="relative h-36 w-full overflow-hidden rounded-2xl bg-muted">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={previewUrl}
            alt="Предпросмотр фона на телефоне"
            className="h-full w-full object-cover object-center"
          />
        </div>
      </div>
    </div>
  );
}
